import React from 'react';
import EuSouPepsico from '../../assets/images/eusoupepsico.svg'
import { Text } from "@chakra-ui/core";

import { Container, Content } from './styles';

const Begin: React.FC = () => {
  return (
    <Container>
        <Content>
            <div className="img" />
            <div>
                <img src={EuSouPepsico} alt="smille" />
                <Text color="#424242" textAlign="center">
                    Você concluiu o processo de inscrição.
                </Text>
                <Text color="#424242" textAlign="center">
                    Agradecemos sua participação!
                </Text>
                <Text color="#424242" textAlign="center" marginTop="20px">
                    Você receberá um e-mail com as orientações para realizar o agendamento através do aplicativo!
                </Text>
            </div>
        </Content>
    </Container>
  );
}

export default Begin;